var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDoc = function SvgDoc(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-14": 11,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-32": 24,
    "data-width-36": 27,
    "data-width-40": 30,
    "data-width-72": 53,
    viewBox: "0 0 11.8 11.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 11.667h8.667a1.5 1.5 0 0 0 1.533-1.5V4.42a1.83 1.83 0 0 0-.54-1.333L8.613.54A1.83 1.83 0 0 0 7.28 0H1.5A1.5 1.5 0 0 0 0 1.5v8.667a1.5 1.5 0 0 0 1.5 1.5M1.148 1.149A.5.5 0 0 1 1.5 1h5.78a.83.83 0 0 1 .593.247l2.547 2.547a.83.83 0 0 1 .247.593v5.78a.507.507 0 0 1-.5.5H1.5a.506.506 0 0 1-.5-.5V1.5a.5.5 0 0 1 .148-.351m3.89 6.547a1.22 1.22 0 0 0 2.082-.862v-.667a1.22 1.22 0 1 0-2.44 0v.667c0 .323.129.634.357.862m.546-1.845a.447.447 0 0 1 .763.316v.667a.447.447 0 0 1-.894 0v-.667c0-.118.047-.232.131-.316m-2.35 2.203H2.5a.38.38 0 0 1-.38-.387V5.334a.38.38 0 0 1 .38-.387h.733A1.293 1.293 0 0 1 4.5 6.234v.533a1.293 1.293 0 0 1-1.267 1.287m-.38-.774h.38a.513.513 0 0 0 .52-.513v-.533a.513.513 0 0 0-.52-.514h-.38zm4.85.416a1.22 1.22 0 0 0 1.508.17 1.2 1.2 0 0 0 .448-.499.387.387 0 1 0-.667-.333.43.43 0 0 1-.4.246.447.447 0 0 1-.446-.446v-.667a.447.447 0 0 1 .446-.447.43.43 0 0 1 .4.247.387.387 0 1 0 .667-.333 1.22 1.22 0 0 0-2.313.533v.667c0 .323.128.634.357.862",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDoc);
export default ForwardRef;